import PropTypes from "prop-types";
import React from "react";
import { InfoBox } from "ui/info-box";

function NetworkStatsBox(props) {
  const { network } = props;
  const { uptime } = network;

  const uptimeValue = uptime ? `${uptime.toFixed(2)}%` : "--";

  return (
    <InfoBox
      title="Uptime (yesterday)"
      desc={uptimeValue}
      color="aqua"
      icon="bar-chart"
    />
  );
}

NetworkStatsBox.propTypes = {
  network: PropTypes.object.isRequired,
};

export { NetworkStatsBox };
